import styled from '@emotion/styled';

import { ListBox } from '../list-box/ListBox';

import { scrollbarDark } from '../../theme/elements/scrollbars';
import { su } from '../../theme/functions/su';

export function SubNav() {}

SubNav.Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  flex: 1 1 auto;
  min-width: 0;
`;

SubNav.SearchFieldWrapper = styled.div`
  flex: 0 0 auto;
  padding: 0 ${su(2)} ${su(2)};
`;

SubNav.ListBox = styled(ListBox)`
  ${scrollbarDark};
  flex: 1 1 auto;
  min-width: 0;
  overflow-y: auto;
`;
